import http from '@/services/http.js';

export const addAccount = async (accountData) => {
  const response = await http.post(`/videoapi/user/register`, accountData);
  return response;
};

export const updateAccountStatus = async (user_id, is_active) => {
  try {
    const payload = { user_id, isactive: is_active };
    const response = await http.post(`/videoapi/user/update-status`, payload);

    if (response.status === 200) {
      return {
        success: true,
        message: response.data?.message || '更新成功',
      };
    }

    return {
      success: false,
      error: response.data?.message || '更新失败',
    };
  } catch (error) {
    console.error('更新账户状态失败', error);
    throw error;
  }
};

export const updateAccountDetails = async (id, data) => {
  const response = await http.put(`/videoapi/user/update/${id}`, data);
  return response;
};

export const getActiveStaffData = async (role_id) => {
  try {
    const response = await http.get(`/videoapi/infoUpload/getUserRoles/${role_id}`);
    return response.data;
  } catch (error) {
    console.error('获取人员数据失败', error);
  }
};

export const getAllStaffData = async (role_id) => {
  try {
    const response = await http.get(`/videoapi/infoUpload/getAllStaffs/${role_id}`);
    return response.data;
  } catch (error) {
    console.error('获取所有人员数据失败', error);
  }
};

export const fetchAllCompanyData = async () => {
  try {
    const response = await http.get(`/videoapi/infoUpload/fetchAllCompanyData`);
    return response.data;
  } catch (error) {
    console.error('获取总数据失败', error);
    throw error;
  }
};

export const assignStaff = async (client_id, fieldName, fieldValue) => {
  try {
    const response = await http.post(`/videoapi/infoUpload/assignStaff`, {
      client_id,
      fieldName,
      fieldValue,
    });
    return response;
  } catch (error) {
    console.error('自动分配失败', error);
    throw error;
  }
};
